var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48 80h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80 80h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 80h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 432h141.058l-4.364 48h-24.694v16h176v-16h-24.694l-4.364-48h141.058a32.036 32.036 0 0 0 32-32v-176h-16v128h-432v-224h208v-16h-208v-32a16.019 16.019 0 0 1 16-16h248v-16h-248a32.036 32.036 0 0 0 -32 32v320a32.036 32.036 0 0 0 32 32zm247.24 48h-94.48l4.364-48h85.752zm168.76-112v32a16.019 16.019 0 0 1 -16 16h-400a16.019 16.019 0 0 1 -16-16v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 384h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 192a48 48 0 1 0 -48-48 48.055 48.055 0 0 0 48 48zm0-80a32 32 0 1 1 -32 32 32.036 32.036 0 0 1 32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.159 78.868a7.993 7.993 0 0 0 -7.8 4.928l-10.75 25.954a8 8 0 0 0 2.03 9l19.65 17.74v15.02l-19.65 17.74a8 8 0 0 0 -2.03 9l10.75 25.954a8 8 0 0 0 7.8 4.928l26.439-1.35 10.62 10.62-1.35 26.439a8 8 0 0 0 4.928 7.8l25.954 10.75a8 8 0 0 0 9-2.03l17.74-19.65h15.02l17.74 19.65a8 8 0 0 0 9 2.03l25.954-10.75a8 8 0 0 0 4.928-7.8l-1.35-26.439 10.62-10.62 26.439 1.35a7.98 7.98 0 0 0 7.8-4.928l10.75-25.954a8 8 0 0 0 -2.03-9l-19.65-17.74v-15.02l19.65-17.74a8 8 0 0 0 2.03-9l-10.75-25.95a8 8 0 0 0 -7.8-4.928l-26.441 1.346-10.618-10.618 1.35-26.439a8 8 0 0 0 -4.928-7.8l-25.954-10.752a8 8 0 0 0 -9 2.03l-17.74 19.65h-15.02l-17.74-19.65a8 8 0 0 0 -9-2.03l-25.95 10.75a8 8 0 0 0 -4.928 7.8l1.35 26.439-10.622 10.62zm35.241 15.178 15.646-15.646a8 8 0 0 0 2.333-6.065l-1.244-24.351 15.522-6.429 16.343 18.095a8 8 0 0 0 5.938 2.639h22.13a8 8 0 0 0 5.932-2.639l16.34-18.1 15.522 6.429-1.244 24.351a8 8 0 0 0 2.333 6.065l15.649 15.651a8.012 8.012 0 0 0 6.065 2.333l24.351-1.244 6.429 15.522-18.095 16.343a8 8 0 0 0 -2.639 5.938v22.13a8 8 0 0 0 2.639 5.932l18.1 16.34-6.429 15.522-24.351-1.244a7.992 7.992 0 0 0 -6.065 2.333l-15.651 15.649a8 8 0 0 0 -2.333 6.065l1.244 24.351-15.522 6.429-16.343-18.095a8 8 0 0 0 -5.938-2.639h-22.13a8 8 0 0 0 -5.932 2.639l-16.34 18.1-15.522-6.429 1.244-24.351a8 8 0 0 0 -2.333-6.065l-15.649-15.651a8.015 8.015 0 0 0 -6.065-2.333l-24.351 1.244-6.429-15.522 18.095-16.343a8 8 0 0 0 2.639-5.938v-22.13a8 8 0 0 0 -2.639-5.932l-18.1-16.34 6.429-15.522 24.351 1.244a8.005 8.005 0 0 0 6.07-2.336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 160a8 8 0 0 0 -8-8h-32a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24h-16v-16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 160a8 8 0 0 0 -8-8h-32a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24h-16v-16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 160a8 8 0 0 0 -8-8h-32a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24h-16v-16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 224a8 8 0 0 0 -8-8h-32a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24h-16v-16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 224a8 8 0 0 0 -8-8h-32a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24h-16v-16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 224a8 8 0 0 0 -8-8h-32a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24h-16v-16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 280h-32a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0 -8-8zm-8 32h-16v-16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 280h-32a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0 -8-8zm-8 32h-16v-16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 280h-32a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0 -8-8zm-8 32h-16v-16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 280h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 280h136v16h-136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 312h152v16h-152z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRba);
export default __webpack_public_path__ + "static/media/RBA.360b55ae.svg";
export { ForwardRef as ReactComponent };